/*
 * Wraps images inside article content in the polaroid frame.
 *
 * Article content is a single block of editor HTML, so the frame cannot be
 * added in Liquid and CSS cannot introduce the two extra layers a frame and a
 * tape need. The wrapper is built here instead, producing the same DOM the
 * blog cards render so both are styled by component-polaroid.css.
 *
 * A span, not a div: editor images usually sit inside a paragraph, and a div
 * there is invalid and gets reparented by the HTML parser.
 */
class ArticlePolaroid extends HTMLElement {
  connectedCallback() {
    const frameSrc = this.dataset.frame;
    const tapeSrc = this.dataset.tape;
    if (!frameSrc || !tapeSrc) return;

    const images = this.querySelectorAll('img');
    images.forEach((img) => {
      // Skip anything already framed, and anything the theme itself rendered.
      if (img.closest('.polaroid')) return;
      if (img.classList.contains('polaroid__frame')) return;
      if (img.classList.contains('polaroid__tape')) return;

      // Per-image opt-out. closest() rather than classList so the marker can go
      // on the image or on anything wrapping it, whichever is easier to reach
      // in the editor's HTML view.
      if (img.closest('.no-polaroid, .no-frame, [data-no-polaroid]')) return;

      const polaroid = document.createElement('span');
      polaroid.className = 'polaroid article-polaroid';

      const window_ = document.createElement('span');
      window_.className = 'polaroid__window';

      // Put the polaroid where the image was, then move the image inside it.
      img.replaceWith(polaroid);
      window_.appendChild(img);
      polaroid.appendChild(window_);

      const frame = new Image();
      frame.src = frameSrc;
      frame.alt = '';
      frame.setAttribute('role', 'presentation');
      frame.className = 'polaroid__frame';
      frame.loading = 'lazy';
      polaroid.appendChild(frame);

      const tape = new Image();
      tape.src = tapeSrc;
      tape.alt = '';
      tape.setAttribute('role', 'presentation');
      tape.className = 'polaroid__tape';
      tape.loading = 'lazy';
      polaroid.appendChild(tape);
    });
  }
}

if (!customElements.get('article-polaroid')) {
  customElements.define('article-polaroid', ArticlePolaroid);
}
